import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import { useTranslation } from 'react-i18next';
import ApiClient from "../../../services/api-client"
import Commons from '../../../util/commons'

const SelfPricingRenderer = forwardRef((props, ref) => {


    const [checked, setChecked] = useState(props.value ? props.value : false);
    const [disabled, setDisabled] = useState(true);
    const { t } = useTranslation();

    const onChangeStatus = (e) => {
        props.node.setDataValue("selfPricing", e.target.checked);
        props.api.stopEditing();

        var opts = [];
        var myDataInvoiceType = null;
        if (props.colDef.cellRendererParams && props.colDef.cellRendererParams.myDataInvoiceType) {
            myDataInvoiceType = props.colDef.cellRendererParams.myDataInvoiceType;
        }
        else {
            myDataInvoiceType = props.node.data.invoiceType.myDataInvoiceType;
        }



        var expenses = Boolean(Commons.isOnGroup(myDataInvoiceType, "isExpense") || props.node.data.selfPricing);
        ApiClient.getClassificationCategoriesOfMyDataInvoice(myDataInvoiceType, expenses).then(response => {
            var data = response.data;
            var _optionIncClassCategories = [];

            data.forEach(element => {
                var _classificationCategory;
                var _classificationValues;
                _classificationCategory = element.classificationCategory;
                _classificationValues = element.classificationValues;

                var prefix = _classificationCategory.replace("CATEGORY_", "") + ") ";
                _optionIncClassCategories.push({
                    value: _classificationCategory,
                    label: prefix + t(_classificationCategory),
                    classificationValues: _classificationValues,
                });
            });
            if (props.colDef.cellRendererParams && props.colDef.cellRendererParams.myDataInvoiceType) {
                if( expenses){
                    props.colDef.cellRendererParams.setExpensesClassCategories(_optionIncClassCategories)
                }
                else{
                    props.colDef.cellRendererParams.setIncomeClassCategories(_optionIncClassCategories)
                }
                
            }
            else{
                props.node.setDataValue("classificationCategoryTypes", _optionIncClassCategories);
            }
           
        
            props.node.setDataValue("classificationCategory", { value: undefined, label: undefined });
            props.node.setDataValue("classificationValue", { value: undefined, label: undefined });
        },
            error => {
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        );
    }

    useEffect(() => {
        if (props.node?.data?.invoiceType) {
            const myDataInvoiceType = props.node.data.invoiceType.myDataInvoiceType;
            if (Commons.isOnGroup(myDataInvoiceType, "allowSelfPrice")) {
                setDisabled(false);
            } else {
                setDisabled(true);
            }
        }
    }, [props.node?.data?.invoiceType]);

    useEffect(() => {
        if (props.colDef?.cellRendererParams?.myDataInvoiceType) {
            const myDataInvoiceType = props.colDef.cellRendererParams.myDataInvoiceType;
            if (Commons.isOnGroup(myDataInvoiceType, "allowSelfPrice")) {
                setDisabled(false);
            } else {
                setDisabled(true);
            }
        }
    }, [props.colDef?.cellRendererParams?.myDataInvoiceType]);

    useImperativeHandle(ref, () => {
        return {
            refresh(params) {
                var val = props.getValue();
                if (val != undefined) {
                    setChecked(val);
                }
            }
        };
    });
    return <span className="editableCell"><input onChange={onChangeStatus} disabled={disabled} type="checkbox" checked={checked}></input></span>
});

export default SelfPricingRenderer;